import { render, staticRenderFns } from "./AccountSettingToken.vue?vue&type=template&id=e4db8e04"
import script from "./AccountSettingToken.vue?vue&type=script&lang=js"
export * from "./AccountSettingToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports